import { Guid, Nillable } from '@web/utils';
import { AdminProductQuantityHistoryReasonType } from '../enums/admin-product-quantity-history-reason-type';
import { AdminProductQuantityHistoryOrder } from './admin-product-quantity-history-order';

export class AdminProductQuantityHistoryCollectionItem {
  public constructor(
    private readonly data: {
      change: number;
      createdAt: Date;
      createdBy?: Nillable<string>;
      id: Guid;
      order?: Nillable<AdminProductQuantityHistoryOrder>;
      quantityAfterChange: number;
      quantityBeforeChange: number;
      reason: AdminProductQuantityHistoryReasonType;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get change(): number {
    return this.data.change;
  }

  public get absoluteChange(): number {
    return Math.abs(this.data.change);
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get createdBy(): Nillable<string> {
    return this.data.createdBy;
  }

  public get order(): Nillable<AdminProductQuantityHistoryOrder> {
    return this.data.order;
  }

  public get quantityAfterChange(): number {
    return this.data.quantityAfterChange;
  }

  public get quantityBeforeChange(): number {
    return this.data.quantityBeforeChange;
  }

  public get reason(): AdminProductQuantityHistoryReasonType {
    return this.data.reason;
  }
}
